import { Tooltip } from "antd";

import { ReactComponent as IconKYT } from "images/KYT.svg";
import { LinkButton } from "ui";

import { useState } from "react";
import { downloadFileBlob, parseErrorMessage } from "utils";
import { ENDPOINTS, NormalizedError } from "services";
import { useNotificationContext } from "providers";
import { NOTIFICATION_TYPE_ENUM } from "interfaces";

import styles from "./buttonKYT.module.css";

interface IProps {
  checkId: string;
  tooltip: string;
}
export const ButtonDownloadKYT = (props: IProps) => {
  const { checkId, tooltip } = props;
  const { openNotification } = useNotificationContext();

  const [loading, setLoading] = useState(false);

  const handleDownloadReportKYT = async () => {
    setLoading(true);
    try {
      await downloadFileBlob(ENDPOINTS.manualCheckReport(checkId), true);
    } catch (e: unknown) {
      openNotification({
        type: NOTIFICATION_TYPE_ENUM.ERROR,
        description: parseErrorMessage(e as NormalizedError),
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <LinkButton disabled={loading} className={styles.button} onClick={handleDownloadReportKYT}>
      <Tooltip title={tooltip}>
        <IconKYT className={"cursor-pointer"} />
      </Tooltip>
    </LinkButton>
  );
};
